import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  idRequests: { value: "", matchMode: "equals" },
  title: { value: "", matchMode: "contains" },
  companyName: { value: "", matchMode: "contains" },
  companyLocation: { value: "", matchMode: "contains" },
  jobType: { value: "", matchMode: "equals" },
  listedDate: { value: "", matchMode: "equals" },
  experienceLevel: { value: "", matchMode: "equals" },
  sectorJob: { value: "", matchMode: "equals" },
  functionOnJob: { value: "", matchMode: "equals" },
  salary: { value: "", matchMode: "equals" },
};

export const useFilterLinkedinCardsStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
